import React, { FC } from 'react';
import { SrWidget } from './SrWidget';

export interface SrWidgetMatchScoringProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
}

export const SrWidgetMatchScoring: FC<SrWidgetMatchScoringProps> = ({ matchId, ...props }) => {
    const widgetProps = { matchId: matchId, disableWidgetHeader: true, disableMatchHeader: true };
    return <SrWidget widgetName="match.scoringProbabilityPerPeriod" widgetProps={widgetProps} {...props} />;
};
